import { z } from 'zod';

export interface BulkUserOperationRequestDto {
  userIds: string[];
  operation: BulkUserOperationType;
  data?: BulkUserOperationData;
}

export interface BulkUserOperationData {
  // For app access toggle
  hasAppAccess?: boolean;
  // For team assignments
  teamIds?: number[];
  // TODO: Add other data types as needed
}

export enum BulkUserOperationType {
  DELETE_USERS = 'DELETE_USERS',
  TOGGLE_APP_ACCESS = 'TOGGLE_APP_ACCESS',
  ASSIGN_TEAMS = 'ASSIGN_TEAMS',
  REMOVE_TEAMS = 'REMOVE_TEAMS',
}

// Zod schemas for validation
export const BulkUserOperationRequestSchema = z.object({
  userIds: z.array(z.string()).min(1, 'At least one user ID is required'),
  operation: z.nativeEnum(BulkUserOperationType),
  data: z
    .object({
      hasAppAccess: z.boolean().optional(),
      teamIds: z.array(z.number()).optional(),
    })
    .optional(),
});

export const BulkUserOperationResponseSchema = z.object({
  successCount: z.number(),
  failureCount: z.number(),
  results: z.array(
    z.object({
      userId: z.string(),
      success: z.boolean(),
      message: z.string().optional(),
    })
  ),
  errors: z.array(
    z.object({
      userId: z.string(),
      error: z.string(),
      code: z.string().optional(),
    })
  ),
});

export type BulkUserOperationRequest = z.infer<
  typeof BulkUserOperationRequestSchema
>;
export type BulkUserOperationResponse = z.infer<
  typeof BulkUserOperationResponseSchema
>;

/** Status of a guide when an asynchronous bulk-delete job starts. */
export const BulkGuideDeleteRosterStatusSchema = z.literal('pending');

/** One guide returned in the initial asynchronous bulk-delete roster. */
export const BulkGuideDeleteRosterGuideSchema = z.object({
  userId: z.string().uuid(),
  name: z.string(),
  status: BulkGuideDeleteRosterStatusSchema,
});

/** Initial response for an asynchronous bulk guide-delete job. */
export const BulkGuideDeleteJobDtoSchema = z.object({
  jobId: z.string().uuid(),
  guides: z.array(BulkGuideDeleteRosterGuideSchema),
});

/** Initial response for an asynchronous bulk guide-delete job. */
export type BulkGuideDeleteJobDto = z.infer<
  typeof BulkGuideDeleteJobDtoSchema
>;
